import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * 合并 Tailwind CSS 类名工具函数
 *
 * 使用 clsx 处理条件类名，使用 tailwind-merge 智能合并 Tailwind 类（解决样式冲突）。
 *
 * @example
 * cn('text-color-1', 'bg-1', isActive && 'text-primary-6')
 * cn('px-4 py-2', 'px-6') // → 'px-6 py-2' (tailwind-merge 智能合并)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
